export { Loader } from './Loader.styles';
